<!--
 * @Author: wj
 * @Date: 2024-01-10 14:12:27
 * @LastEditTime: 2024-02-27 14:35:15
 * @LastEditors: wj
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp-cloud-app\src\views\medical-edu\detail\exam\index.vue
-->

<template>
  <div class="exam">
    <div>
      <span class="stu">{{ detailData.liveStatus }}</span>
      <el-image class="image" :src="src"></el-image>

    </div>
    <div class="dphName">{{ detailData.dataName }}</div>
    <div class="firstNav">
      <firstNav @getClickFirstnav="getClickFirstnav" :navData="firstNavData" :indexs="indexs"></firstNav>
    </div>
    <div class="act">
      <div v-if="indexs === 0">
        <div class="content_b">
          <div class="content_a">课程名称:</div>
          <div class="dl">{{ detailData.seriesName }}</div>
        </div>
        <div class="content_b">
          <div class="content_a">考试时间:</div>
          <div class="dl"><span>{{ detailData.startDate }}</span> {{ detailData.startTime }}-{{ detailData.endTime }}</div>
        </div>
        <div class="content_b">
          <div class="content_a">考试简介:</div>
          <div class="dl">{{ detailData.summary }}</div>
        </div>
      </div>
      <div v-if="indexs === 1">
        <commentDiv :datainfo='datainfo'></commentDiv>
      </div>
    </div>
<div v-if="indexs === 0">
  <div class="btn" v-if=" detailData.liveStatus =='进行中' &&  !answer " @click="turnAnswer">在线答题</div>
    <div class="btn" v-if=" answer || detailData.liveStatus =='已结束'" @click="turnAnswerCheck">成绩查看</div>
</div>
  </div>
</template>

<script>
import firstNav from '../../../../components/basics/first-nav';
import commentDiv from '../../comment/index';

export default {
  components: {
    firstNav,
    commentDiv
  },
  data () {
    return {
      // 用于判断是否答过题
      answer: false,
      indexs: 0,
      detailData: {},
      urlData: {},
      dataid: 0,
      moduleId: 0,
      moduleTypeCode: 0,
      src: '',
      firstNavData: [
        {
          text: '课程详情',
          status: 0
        },
        {
          text: '参与讨论',
          status: 1
        }

      ],
      datainfo: {
        dataId: this.$route.query.dataId,
        moduleId: this.$route.query.moduleId
      }
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    // this.urlData = JSON.parse(window.localStorage.getItem('stuTempData'));
    this.urlData = this.$route.query
    this.dataid = this.urlData.dataId;
    this.moduleId = this.urlData.moduleId;
    this.moduleTypeCode = this.urlData.moduleTypeCode
    this.info()
    this.checkAnswer()
  },
  methods: {
    info () {
      const Version = this.$version;
      this.$axios
        .post('edu/exam/data/detail', { data: { id: this.dataid }, version: Version })
        .then((res) => {
          this.detailData = res.data;
          this.src = this.utils.getFileUrl(Number(res.data.coverId))
          const t1 = res.data.startDate + ' ' + res.data.startTime
          const t2 = res.data.startDate + ' ' + res.data.endTime
          var now = new Date();
          var year = now.getFullYear(); // 获取完整的年份(4位,1970-????)
          var month = now.getMonth() + 1; // 获取当前月份(0-11,0代表1月)
          var day = now.getDate(); // 获取当前日(1-31)
          var hour = now.getHours(); // 获取当前小时数(0-23)
          var minute = now.getMinutes(); // 获取当前分钟数(0-59)
          var second = now.getSeconds(); // 获取当前秒数(0-59)
          var t3 = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
          this.detailData.liveStatus = t1 > t3 ? '未开始' : t2 > t3 ? '进行中' : '已结束'
          // if (!res.data.startDate) {
          //   this.detailData.liveStatus = '进行中'
          // }
        });
    },
    // tab事件
    getClickFirstnav (e) {
      this.indexs = e;
    },
    // 判断是否已经提交过试题
    checkAnswer () {
      const Version = this.$version
      const Data = {
        dataId: this.dataid,
        moduleId: this.moduleId
      }
      this.$axios.post('/edu/exam/submit/check', { data: Data, version: Version }).then((res) => {
        if (res.data === true) {
          this.answer = true
        } else {
          this.answer = false
        }
      })
    },
    // 在线答题
    turnAnswer () {
      // newId 代表时学习计划中传过来的
      // const data = JSON.parse(window.localStorage.getItem('stuTempData'));
      const data = this.$route.query
      if (data && data.newId) {
        this.$router.push({ path: '/search/ques', query: { dataId: data.dataId, id: data.newId, moduleId: data.moduleId } })
      } else {
        this.$router.push({ name: '/search/ques', query: { dataId: data.dataId, moduleId: data.moduleId } })
      }
    },
    // 成绩查看
    turnAnswerCheck () {
      // const data = JSON.parse(window.localStorage.getItem('stuTempData'));
      const data = this.$route.query
      if (data && data.newId) {
        this.$router.push({ path: '/search/ques', query: { dataId: data.dataId, id: data.newId, moduleId: data.moduleId, check: 1 } })
      } else {
        this.$router.push({ path: '/search/ques', query: { dataId: data.dataId, moduleId: data.moduleId, check: 1 } })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
<style lang='scss' scoped>
.exam {
  margin-top: 50px;
}

.stu {
  display: inline-block;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  color: #ffffff;
  padding-top: 5px;
  font-size: 14px;
  text-align: center;
  position: fixed;
  z-index: 9999;
  top:50px;
}

.image {
  width: 100%;
  height: 150px;
}

.dphName {
  font-family: PingFangSC-Semibold;
  font-size: 21px;
  color: #333333;
  letter-spacing: 0.27px;
  font-weight: 600;
  padding-bottom: 6px;
  background-color: $white;
  padding: 22px 14px 6px 14px;
  margin-top: -9px;
  border-radius: 10px 10px 0 0;
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  /* 隐藏溢出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.firstNav ::v-deep .normalNav {
  box-shadow: none;
}

.act {
  margin-top: 20px;
  padding: 0 14px 14px 14px;

  .content_b {

    display: flex;
    margin-top: 12px;
    width: 100%;
    justify-content: space-between;

    .content_a {
      margin-right: 10px;
      width: 72px;
    }

    .dl {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span{
        margin-right:10px ;
      }
    }
  }
}
.btn{
  position: fixed;
  bottom: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 21px;
    color: #ffffff;
    background-color: #408fee;
    text-align: center;
    cursor: pointer;
  }
</style>




